export default "__VITE_ASSET__f2afdf91__"